// src/oura/delivery/flag.ts
//
// Whether Delivery replaces Fixes and Plan here: wherever it is served, live
// behind its own switch (VITE_ENABLE_OURA_DELIVERY_LIVE) or the sample store
// on a local fixtures run (the dev server, VITE_ENABLE_OURA_LIVE_API not
// "true"). A build is never a fixtures run, so one missing its switches keeps
// Fixes and Plan, as staging and production do until the backend routes ship.
// No imports, so the router and the rail can read it.

export const DELIVERY_ON =
    import.meta.env.VITE_ENABLE_OURA_DELIVERY_LIVE === "true" ||
    (import.meta.env.DEV && import.meta.env.VITE_ENABLE_OURA_LIVE_API !== "true");

// The Checklist's Done by hand (#4648, backend #6463): staff mark an item, or a whole deliverable,
// Done. Behind its own switch, VITE_ENABLE_OURA_FORCE_DONE; on a local fixtures run it shows on
// the sample store. The rows still hide it when the server does not send `forcedDone`.
export const FORCE_DONE_ON =
    import.meta.env.VITE_ENABLE_OURA_FORCE_DONE === "true" ||
    (import.meta.env.DEV && import.meta.env.VITE_ENABLE_OURA_LIVE_API !== "true");
